import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';


interface TaxRange {
  label: string;
  value: string;
}

@Component({
  selector: 'modal-ir',
  templateUrl: './modal-ir.component.html',
  styleUrls: ['./modal-ir.component.scss'],
})


export class ModalIrComponent implements OnInit{

  constructor(
    private modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService
  ) {
  }

   public goBack() {
    this.modalController.dismiss();
  }

  tableData: TaxRange[] = [];

  translations = {
    "pt-br": [
      { label: 'Até 180 dias', value: '22.5%' },
      { label: 'De 181 a 360 dias', value: '20%' },
      { label: 'De 361 a 720 dias', value: '17.5%' },
      { label: 'Acima de 720 dias', value: '15%' }
    ],
    "en-us": [
      { label: 'Up to 180 days', value: '22.5%' },
      { label: 'From 181 to 360 days', value: '20%' },
      { label: 'From 361 to 720 days', value: '17.5%' },
      { label: 'Above 720 days', value: '15%' }
    ]
  };


  ngOnInit() {
    const layoutConfigValue = this.layoutConfigService.getSavedConfig();
    const lang = layoutConfigValue.wlTheme.languageDefault;

    this.tableData = this.translations[lang];
  }


  
}
